import React from "react";
import { Header, Icon, Segment, Grid } from "semantic-ui-react";
import BAGForm from "./bag.js";

const App = props => {
  return (
    <Grid centered columns={2} doubling>
      <Grid.Row centered columns={2} />
      <Grid.Column>
        <Segment padded="very">
          <Header as="h2" icon textAlign="center">
            <Icon name="linkify" circular />
            BAG-Schnittstelle
            <Header.Subheader>
              Verbinden Sie Ihren BAG-Auftrag mit BPO
            </Header.Subheader>
          </Header>
          <BAGForm />
        </Segment>
      </Grid.Column>
    </Grid>
  );
};



export default App;



// WEBPACK FOOTER //
// ./src/containers/app/index.js